<script>
import {mapActions, mapState} from "vuex";
import AlertMessage from '@/components/AlertMessage.vue'

/**
 *
 */
export default {
  name: "EdiRequestAuthentications",
  components: {
    AlertMessage
  },
  comments: "EDI申請入口",
  data() {
    return {
    }
  },
  computed: {
    ...mapState('alertMessage', {
      isShowAlert: 'isShow'
    })
  },
  created() {
    const token = this.$route.params.token
    this.authentication(token)
  },
  methods: {
    ...mapActions('EdiRequestAuthentication', {
      auth: "auth"
    }),
    ...mapActions('EdiRequestRegistration', {
      resetState: 'resetState',
    }),
    /**
     * アクセストークンの有効性チェック
     * @param token
     */
    authentication (token) {
      this.auth({ token: token }).then(() => {
        this.resetState();
        this.$router.replace({name: 'EdiRequestRegistrations', params: { token: token }}, () => {})
      })
    },
  },
}
</script>

<template>
<v-container :fluid="true">
  <alert-message />
  <div v-if="!isShowAlert">EdiRequest Authentication Loading...</div>
</v-container>
</template>

<style scoped lang="scss">

</style>
